import MessagesRequest from "../ws/MessagesRequest";
import SendMessageRequest from "../ws/SendMessageRequest";
import {I18nUtils} from "../../../../../../i18n/I18nUtils";
import Alert from "react-s-alert";
import ArchiveMessageRequest from "../ws/ArchiveMessageRequest";

export const MESSAGES_UPDATE = 'messages-update';
export const MESSAGES_LOADING = 'messages-loading';
export const MESSAGES_ERROR = 'messages-error';
export const MESSAGES_ADD_RESPONSE = 'messages-add-response';
export const MESSAGES_ARCHIVE = 'messages-archive';

export const getMessages = (page = 1, search = '', filter = null, query_ids = {}) => (dispatch) => {

  new MessagesRequest(page, search, filter, query_ids)
    .onPreExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: MESSAGES_UPDATE,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: MESSAGES_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: false });
    })
    .execute();
};

export const sendMessage = (message, selectedTargetCompanyId, queryIds, onSuccess = () => {}) => (dispatch) => {

  new SendMessageRequest(message, selectedTargetCompanyId, null, queryIds)
    .onPreExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: true });
    })
    .onSuccess(data => {
      onSuccess();
      Alert.success(I18nUtils.tr('TR_SEND_MESSAGE_SUCCESS'))
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_SEND_MESSAGE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: false });
    })
    .execute();
};

export const responseMessage = (messageId, message, parentMessageId, onSuccess = () => {}) => (dispatch) => {

  new SendMessageRequest(message, null, parentMessageId)
    .onPreExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: true });
    })
    .onSuccess(response => {
      dispatch({ type: MESSAGES_ADD_RESPONSE, id: messageId, payload: response.data });
      Alert.success(I18nUtils.tr('TR_SEND_MESSAGE_SUCCESS'))
      onSuccess();
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_SEND_MESSAGE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: false });
    })
    .execute();
};

export const archiveMessage = (messageId) => (dispatch) => {

  new ArchiveMessageRequest(messageId)
    .onPreExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: true });
    })
    .onSuccess(response => {
      dispatch({ type: MESSAGES_ARCHIVE, id: messageId });
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_ARCHIVE_MESSAGE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: MESSAGES_LOADING, payload: false });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/actions/messagesActions.js